var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 16V14.3333C13.8333 13.4493 13.4821 12.6014 12.8569 11.9763C12.2318 11.3512 11.384 11 10.4999 11H4.66659C3.78253 11 2.93468 11.3512 2.30956 11.9763C1.68444 12.6014 1.33325 13.4493 1.33325 14.3333V16M17.1666 5.16667V10.1667M19.6666 7.66667H14.6666M10.9166 4.33333C10.9166 6.17428 9.4242 7.66667 7.58325 7.66667C5.7423 7.66667 4.24992 6.17428 4.24992 4.33333C4.24992 2.49238 5.7423 1 7.58325 1C9.4242 1 10.9166 2.49238 10.9166 4.33333Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMate);
export default __webpack_public_path__ + "static/media/addMate.df6af896e5ae6566ff0883b78cbb4241.svg";
export { ForwardRef as ReactComponent };